import { ProjectActions } from '@octopus-do/octopus-project-core'
import { LoaderActions } from '@store/loaders'
import { managerActions } from '@store/reducers/manager/actions'
import { initEmptyProjectActionsSaga } from '@store/reducers/manager/sagas/initEmptyProjectActionsSaga'
import { call, put } from 'redux-saga/effects'

import { DEFAULT_PROJECT_NAME } from '@/constants/constants'
import { ProjectOrigin } from '@/types'
import type { XmlImportActions } from '../actions'
import { countImportedEntities } from '../utils'
import { applyProject } from './applyProject'
import { waitForBaseProject, waitForProjectEntities } from './waits'

export function* importXml({
  payload: { model, teamId },
}: ReturnType<typeof XmlImportActions.import>) {
  yield put(LoaderActions.set('project_create'))

  try {
    yield call(initEmptyProjectActionsSaga)
    yield call(waitForBaseProject)

    yield call(applyProject, { model })
    yield call(waitForProjectEntities, countImportedEntities(model))

    yield put(
      ProjectActions.settings.updateTitle({
        title: model.projectTitle || DEFAULT_PROJECT_NAME,
      })
    )

    yield put(
      managerActions.saveProjectSaga({
        teamId: teamId || null,
        ignoreAuthenticated: true,
        origin: ProjectOrigin.IMPORT,
      })
    )
  } finally {
    yield put(LoaderActions.unset('project_create'))
  }
}
